import { Routes, Route } from "react-router-dom";
import ConfirmationsPage from "./pages/ConfirmationsPage";

export const ConfirmationsNavigation = () => {
  return (
    <Routes>
      <Route index element={<ConfirmationsPage />} />
    </Routes>
  );
};
